import { SingleRelaySwitchScheduleEventDeviceConfig } from '@thingslog/repositories';
import { EventConfigFactory } from './EventConfigFactory';

export class SingleRelaySwitchFactory implements EventConfigFactory {
  public create(deviceNumbers: string[]): SingleRelaySwitchScheduleEventDeviceConfig {
    return {
      '@type': 'SINGLE_RELAY_SWITCH',
      deviceCommand: 'SINGLE_RELAY_SWITCH',
      deviceNumbers,
      requiredState: 'OFF',
      sensorIndex: 0,
    };
  }
}
